import { useEffect, useState } from 'react';
import Styles from "../../styles.module.scss";
import SideMenu from "../../sideMenu";
import DashboardHeader from "../../dashboardHeader";
import Headline4 from "../../../../components/headings/Headline4";
import FromHead from "../../../../components/headings/FromHead";
// import FormInput from "../../../../components/field";
import { Icon } from '@iconify/react';
import Button from '../../../../components/button';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FormInput } from '../../../../wrappers/formInput';
import { makeSideBarActive } from '../../../../utils/EllowUtils';
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import { Auth } from "aws-amplify";
import NotificationAlert from '../../../../components/notification';
import mixpanelData, { viewedpageMixpanel } from '../../../../utils/mixpanel';


export type SettingFormFields = {
    oldPassword: string,
    newPassword: string,
    confirmPassword: string
  };

  const validationSchema = Yup.object({
    oldPassword: Yup.string()
      .required("Field is required"),
    newPassword: Yup.string()
      .required("Field is required"),
    confirmPassword: Yup.string()
      .required("Field is required")
      .oneOf([Yup.ref('newPassword'), null], "Passwords don't match!")
  });



function Settings() {

    const formOptions = { resolver: yupResolver(validationSchema) };
    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm<SettingFormFields>(formOptions);
    
    const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 0)
    const [notification, setNotification] = useState<boolean>(false)
    const [error, setError] = useState<string>('')
    const metadata: any = JSON.parse(localStorage.getItem("profile_metadata") || "");
    const [togglepass1, setTogglepass1] = useState<boolean>(false)
    const [togglepass2, setTogglepass2] = useState<boolean>(false)
    const [togglepass3, setTogglepass3] = useState<boolean>(false)

    useEffect(() => {
        viewedpageMixpanel();
      })

    const onSubmit = (data: any) => {
        if(data.oldPassword === data.newPassword)
        {
            setError("Old and new passwords should not be the same")
        }
        else{
            Auth.currentAuthenticatedUser()
            .then(user => {
                return Auth.changePassword(user, data.oldPassword, data.newPassword);
                
            })
            .then(data => {
                setError(' ')
                setNotification(true);
                setTimeout(() => {
                setNotification(false)
                mixpanelData('MWP-Reset Password', {
                    name: metadata.firstName + " " + metadata.lastName,
                    email: metadata.email
                })
                }, 4000);
            })
            .catch(err => errorMessage(err.message));
        }
    }
    
    const errorMessage = (message :  any) =>{
       switch(message){
            case 'Incorrect username or password.' :
                return setError('Current password does not match with the existing password');
            case 'Password did not conform with policy: Password not long enough' :
                return setError('Your new password must be at least 6 characters long');
            case 'Attempt limit exceeded, please try after some time.' :
                return setError('You have exceeded the attempts, please try after some time	');
            default : 
                return setError(' ')
       }
    }

    const onClose = () =>{
        setNotification(false)
    }

    return (
      <section className={Styles.dashboardWrapper}>
        <SideMenu menu={menu}/>
        {  notification && <NotificationAlert closable={true} onClose={onClose} > Password changed succesfully </NotificationAlert> }
        <div className={Styles.dashboardContent}>
            <DashboardHeader/>
            <form>
                <div className="contentBox mb-40">
                    <div className="innerPadd48">
                        <Headline4>Settings</Headline4>
                        <FromHead>Change Password</FromHead>
                        <section className={Styles.personalDetails}>
                        <div className="half-form-wrap">
                            <div className="form-group">
                                <label className="lablel">Current Password</label>
                                <div className='password-filed'>
                                <FormInput<SettingFormFields>
                                    id="oldPassword"
                                    type={togglepass1 ? 'text' : 'password'}
                                    name="oldPassword"
                                    size="medium"
                                    placeholder="Enter your current password"
                                    register={register}
                                    errors={errors}
                                />
                                <Icon icon={togglepass1 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass1((prev) => !prev)}/>
                                </div>
                            </div>
                        </div>
                        <div className="half-form-wrap">
                            <div className="form-group">
                                <label className="lablel">New Password</label>
                                <div className='password-filed'>
                                <FormInput<SettingFormFields>
                                    id="newPassword"
                                    type={togglepass2 ? 'text' : 'password'}
                                    name="newPassword"
                                    size="medium"
                                    placeholder="Enter your new password"
                                    register={register}
                                    errors={errors}
                                />
                                <Icon icon={togglepass2 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass2((prev) => !prev)}/>
                                </div>
                            </div>
                        </div>
                        <div className="half-form-wrap">
                            <div className="form-group">
                                <label className="lablel">Repeat Password</label>
                                <div className='password-filed'>
                                    <FormInput<SettingFormFields>
                                        id="confirmPassword"
                                        type={togglepass3 ? 'text' : 'password'}
                                        name="confirmPassword"
                                        size="medium"
                                        placeholder="Repeat your new password"
                                        register={register}
                                        errors={errors}
                                    />
                                <Icon icon={togglepass3 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass3((prev) => !prev)}/>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            { error && <div><div className="k-form-error">{error}</div></div>} 
                        </div>
                        <div>
                            <Button onClick={handleSubmit(onSubmit)} variant="primary">Update</Button>
                        </div>
                        </section>
                    </div>
                </div>
            </form>
        </div>
      </section>
    );
}
export default Settings